import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Events } from 'ionic-angular';


@Injectable()
export class LanguageProvider {
  languageString = "en";

  constructor(public http: Http, public gateway: GatewayClientProvider, public events: Events) {
  }

  get(key) {
    return key;
  }
}


// WEBPACK FOOTER //
// ./src/providers/language/language.ts